<script setup lang="ts">
import { AppTag } from '@libs/ui';

import { PremadeTripType } from '../../models';
import type { PremadeTrip } from '../../models';

import ReadMoreButton from './ReadMoreButton.vue';

interface PremadeTripHeaderMobileProps {
  tripDetails: PremadeTrip;
}

const props = defineProps<PremadeTripHeaderMobileProps>();

interface PremadeTripHeaderMobileEmits {
  (eventName: 'showFullDescription'): void;
}

const emit = defineEmits<PremadeTripHeaderMobileEmits>();
</script>

<template>
  <div class="premade-trip-header-mobile">
    <img :src="props.tripDetails.imageUrl" alt="trip image" class="image" />
    <div class="content">
      <AppTag
        v-if="props.tripDetails.type === PremadeTripType.AI"
        class="ai-generated-tag"
        type="info"
        :icon="{ name: 'ai', size: '16' }"
      >
        <template #title>{{ $t('planner.ai_generated') }}</template>
      </AppTag>
      <div class="heading">{{ props.tripDetails.headline }}</div>

      <div class="description">
        <slot name="description" />
      </div>
      <ReadMoreButton @click="emit('showFullDescription')" />
    </div>
  </div>
</template>

<style scoped lang="scss">
.premade-trip-header-mobile {
  .image {
    width: 100%;
    height: auto;
    object-fit: cover;
    max-height: 300px;
    aspect-ratio: 16/10;
  }

  .content {
    padding: var(--spacing-16) var(--spacing-16) var(--spacing-24)
      var(--spacing-16);

    .ai-generated-tag {
      margin-bottom: var(--spacing-16);
      @include font-label-s-light;
      padding: var(--spacing-4) var(--spacing-8);
    }

    .heading {
      padding: var(--spacing-8) 0;
      @include font-heading-5;
      color: var(--color-secondary-40);
    }

    .description {
      max-height: 200px;
      overflow: hidden;
    }
  }
}
</style>
